import { Joi, objectSchemaOf } from '../helpers';

export type LogSource =
  | 'client'
  | 'monolith'
  | 'console'
  | 'hil'
  | 'server'
  | 'function'
  | 'external';

export const logSourceSchema = Joi.string().valid(
  'client',
  'monolith',
  'console',
  'hil',
  'server',
  'function',
  'external'
);

export interface ILogData {
  [key: string]: unknown;
}

export interface ILogParamsEntry {
  event: string;
  timestamp: number;
  traceKey?: string;
  source: LogSource;
  data?: ILogData;
}

export type ILogParams = ILogParamsEntry | ILogParamsEntry[];

export const logParamsEntrySchema = objectSchemaOf<ILogParams>({
  event: Joi.string().required(),
  timestamp: Joi.number().required(),
  traceKey: Joi.string(),
  source: logSourceSchema.required(),
  data: Joi.object(),
});

export const logsMultiParamsSchema = Joi.array().items(logParamsEntrySchema);
